import Carousel from "react-material-ui-carousel";
import { Paper } from "@material-ui/core";

export default function ImageCarousel({ imageArr = [], reverse = false }) {
  let localArr = [...imageArr];
  if (reverse) {
    localArr.reverse();
  }
  return (
    <Carousel
      autoPlay={false}
      navButtonsAlwaysVisible={true}
      cycleNavigation={false}
    >
      {localArr.map((item) => (
        <Item key={item.unencryptedDataUrlWrapper} item={item} />
      ))}
    </Carousel>
  );
}

function Item(props) {
  return (
    <Paper style={{ boxShadow: "none" }}>
      <img
        src={
          import.meta.env.VITE_RMS_URL + props.item?.unencryptedDataUrlWrapper
        }
        alt={props.item?.description}
        style={{
          maxWidth: "50vw",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      />
      <p style={{ wordBreak: "break-all" }}>
        Description: {props.item.description}
      </p>
    </Paper>
  );
}
